
import { Outlet } from "react-router-dom";
import Navbar from "../components/common/Navbar";

const LayoutWithoutFooter = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

export default LayoutWithoutFooter;
